// extracted by mini-css-extract-plugin
module.exports = {"approximateWarning":"ApproximateWarning_approximateWarning_kQOHS"};